import React from 'react'
import { connect } from 'react-redux'
// import { useTranslation } from 'react-i18next'
import { Layout } from 'antd'
// import { GlobalOutlined } from '@ant-design/icons'
import {} from // Link,
'react-router'

import classNames from 'classnames'
import styles from './style.module.scss'

const mapStateToProps = ({ settings }) => ({
  // logo: settings.logo,
  isGrayTopbar: settings.isGrayTopbar,
  isCardShadow: settings.isCardShadow,
  isSquaredBorders: settings.isSquaredBorders,
  isBorderless: settings.isBorderless,
  authPagesColor: settings.authPagesColor,
})

const AuthLayout = ({
  children,
  // logo,
  isGrayTopbar,
  isCardShadow,
  isSquaredBorders,
  isBorderless,
  authPagesColor,
}) => {
  // const { t } = useTranslation();

  return (
    <div className={classNames('officemail')}>
      <Layout>
        <Layout.Content>
          <div
            className={classNames(`${styles.container}`, {
              cui__layout__squaredBorders: isSquaredBorders,
              cui__layout__cardsShadow: isCardShadow,
              cui__layout__borderless: isBorderless,
              [styles.white]: authPagesColor === 'white',
              [styles.gray]: authPagesColor === 'gray',
            })}
          >
            <div
              className={classNames(`${styles.topbar}`, {
                [styles.topbarGray]: isGrayTopbar,
              })}
            />
            <div className={styles.containerInner}>{children}</div>
          </div>
        </Layout.Content>
      </Layout>
    </div>
  )
}

export default connect(mapStateToProps)(AuthLayout)
